
import Box from '@mui/joy/Box'

import GarageView from '@/components/garage-view'
import SearchView from '@/components/search-view'
import SuggestedStartTimeSnackbarScope from '@/components/suggested-start-time-snackbar-scope'

export default function GaragesMapView() {
    return (
        <SuggestedStartTimeSnackbarScope placement="website-map">
            <SearchView garagesMap={true} />
            <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                <GarageView />
            </Box>
        </SuggestedStartTimeSnackbarScope>
    )
}
